/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Val2_DescInputs */

const en_dr_room_val2_desc = /** @type {(inputs: Dr_Room_Val2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idea cards stay locked until everyone reveals together. The facilitator summarizes, challenges and critiques from a persona — it never writes a card before people do.`)
};

const id_dr_room_val2_desc = /** @type {(inputs: Dr_Room_Val2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu ide terkunci sampai semua orang reveal bersamaan. Fasilitator merangkum, menantang, dan mengkritik dari sudut persona — tidak pernah menulis kartu sebelum orang menulis dulu.`)
};

/**
* | output |
* | --- |
* | "Idea cards stay locked until everyone reveals together. The facilitator summarizes, challenges and critiques from a persona — it never writes a card before p..." |
*
* @param {Dr_Room_Val2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_val2_desc = /** @type {((inputs?: Dr_Room_Val2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Val2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_val2_desc(inputs)
	return en_dr_room_val2_desc(inputs)
});